import { publicApi } from "./api";

export async function signIn({email, password}: { email: string, password: string }) {
  return publicApi.post('/auth/login', { email, password });
}

export async function forgotPassword({ email }: { email: string }) {
  return publicApi.post('/auth/forgot-password', { email });
}

export async function resetPassword({ token, newPassword }: { token: string, newPassword: string }) {
  return publicApi.post('/auth/reset-password', { token, newPassword });
}